<template>
  <v-row justify="center">
    <v-dialog v-model="visible" persistent max-width="450px">
      <v-card>
        <v-card-title>
          <span class="plt-headline pt-6 pl-4">Event security code</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row align="center" justify="center">
              <v-col cols="12">
                <v-text-field
                  v-model="securityCode"
                  :append-icon="showEyeIcon ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showEyeIcon ? 'text' : 'password'"
                  :rules="[rules.required, securityCodeMatch]"
                  name="input-10-2"
                  label="Visible"
                  class="input-group--focused"
                  autocomplete="off"
                  @click:append="showEyeIcon = !showEyeIcon"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="pb-7">
          <v-spacer />
          <Button
            text="Send"
            @click="$emit('send-security-code', securityCode)"
          />
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import Button from "@/components/Button";
import { mapGetters } from "vuex";

export default {
  name: "SecurityCodeDialog",
  components: {
    Button,
  },
  data() {
    return {
      visible: true,
      showEyeIcon: false,
      securityCode: "",
      rules: {
        required: (value) => !!value || "Required.",
      },
    };
  },
  computed: {
    ...mapGetters(["securityCodeMatch"]),
  },
};
</script>
